import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { useLocation, Link, useParams } from "react-router-dom";
// import { useTheme } from "@mui/material";
// import useMediaQuery from "@mui/material/useMediaQuery";
import { Button, Typography } from '@mui/material';
import { setPopup } from "../../store/slices/popupSlice";
import { useAppDispatch } from "../../assets/hooks";

const ProfileSidebar = (props: any) => {
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const role = localStorage.getItem("role");
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const profileList = [
    {
      path: `/student/${id}/universities`,
      name: "Shortlisted universities",
    },
    { path: `/student/${id}/applied`, name: "Products" },
    { path: `/student/${id}/recommendation`, name: "AI recommendation" },
    { path: `/student/${id}/personal`, name: "Personal information" },
    { path: `/student/${id}/documents`, name: "Documents" },
    { path: `/student/${id}/Education`, name: "Education" },
    { path: `/student/${id}/scores`, name: "Test scores" },
    { path: `/student/${id}/experience`, name: "Work experience" },
    { path: `/student/${id}/activities`, name: "Extra curriculum activities " },
    { path: `/student/${id}/preferences`, name: "Preferences & Skills" },
    { path: `/student/${id}/family`, name: "Family" },
    { path: `/student/${id}/cart`, name: "Cart" },
    { path: `/student/${id}/suggestedPackages`, name: "Suggested Packages" },

  ];

  return (
    <>
      <Box
        sx={{
          background: "#fff",
          p: 2,
          borderRadius: "10px",
          mb: 1,
          display: "flex",
          gap: "10px",
          m: 2
        }}
      >
        <img
          src={props.data?.displayPicSrc !=="" ? props?.data?.displayPicSrc : "https://res.cloudinary.com/dffdp7skh/image/upload/v1706879929/nvitahnrlhvmtcizpthx.png"}
          alt="logo"
          style={{ width: "2.5rem", height: "2.5rem", borderRadius: "50%" }}
        />
        <Box>
          <Typography fontSize="0.9rem">
            {props.data?.firstName}{" "}
            {props.data?.lastName}
          </Typography>
          <Typography fontSize="0.8rem">{props.data?.email}</Typography>
          <Typography fontSize="0.8rem">{props.data?.phone?.countryCode} {props.data?.phone?.number}</Typography>
          <Button
           sx={{
            mt:2,
            color:"#fff",
            background: "#3B3F76",
            borderRadius: "5px",
            textTransform: "none",
            fontSize: "0.8rem",
            "&:hover": {
              background:"#3B3F76",
            },
          }}
          onClick={() =>
            dispatch(
              setPopup({
                show: true,
                data: {
                  container: {
                    name: "suggested",
                    data:{
                      id:props.data._id,
                      editMode:false,
                    },
                    dimensions: {
                      width: "60%",
                    },
                  },
                  type: "custom",
                },
              }))
          }>Suggest a package</Button>
        </Box>

      </Box>
      <Box
        sx={{
          display: "flex",
          background: "#fff",
          boxShadow: 1,
          mx: { xs: 0, md: 5 },
          my: 2,
          width: { md: "250px" },
          borderRadius: "10px",
          // height: "83vh",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <List>
            {profileList.map((item: any) => (
              <ListItem
                key={item.name}
                component={Link}
                to={item.path}
                sx={{ textDecoration: "none", color: "#000", p: 0 }}
              >
                <ListItemButton
                  selected={location.pathname === item.path}
                  sx={{
                    "&:hover": {
                      background: "#fff",
                      color: "#3b3f76",
                    },
                    borderRadius: 0,
                    color: "#3B3F76",
                    "&.Mui-selected": {
                      // textAlign: "center",
                      background: "#fff",
                      color: "#FF751A",
                      borderRadius: 0,

                      "&:hover": {
                        background: "#fff",
                      },
                    },
                  }}
                >
                  {/* {!isMobile ? ( */}
                  <ListItemText
                    primary={item.name}
                    sx={{
                      "& .MuiTypography-root": {
                        fontWeight: location.pathname === item.path ? 600 : 500,
                        borderBottom: location.pathname === item.path ? "2px solid #FF751A " : 0,
                        width: "fit-content"
                      },
                    }}
                  />
                  {/* ) : null} */}
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <List></List>
        </Box>
      </Box>
    </>
  );
};

export default ProfileSidebar;
